<template>
  <div class="on-phone-box">
    <div class="on-phone no-scrollbar">
      <div class="header">
        <div class="left">
          <el-popover
            placement="bottom-start"
            width="360"
            trigger="hover"
            popper-class="on-phone-popover"
            v-if="!beEnding"
          >
            <div class="phone-info">
              <div class="info">通話限時 5 分鐘，消耗 100 幣以續時</div>
              <button class="price" @click="handleContinuous()">
                確定
              </button>
            </div>
            <div slot="reference" class="time-box">
              <img src="./images/icon-clock.png" />
              <span>{{ timeLeft }}</span>
            </div>
          </el-popover>
          <el-popover
            placement="bottom-start"
            width="420"
            trigger="manual"
            v-model="beEnding"
            popper-class="on-phone-popover"
            v-if="beEnding"
          >
            <div class="phone-info">
              <div class="info">通話時間快到囉~消費100幣延長10分鐘</div>
              <button class="price" @click="handleContinuous()">
                確定
              </button>
            </div>
            <div slot="reference" class="time-box">
              <img src="./images/icon-clock.png" />
              <span>{{ timeLeft }}</span>
            </div>
          </el-popover>
        </div>
        <SettingVue></SettingVue>
      </div>
      <div class="content no-scrollbar">
        <div class="user-box">
          <div class="item" v-for="(user, index) of userList" :key="index">
            <div
              class="avatar-box"
              :class="{ speaking: user.volume ? true : false }"
            >
              <!-- <template v-if="!user.isOpen">
                <img
                  class="avatar"
                  src="./images/female.png"
                  alt=""
                  v-show="user.sex === 'female'"
                />
                <img
                  class="avatar"
                  src="./images/male.png"
                  alt=""
                  v-show="user.sex === 'male'"
                />
                <img
                  class="avatar"
                  src="./images/random.png"
                  alt=""
                  v-show="user.sex === 'random'"
                />
              </template> -->
              <img
                class="avatar"
                :src="user.avatar"
                alt=""
                @click="toPlayerDetail(user)"
              />
            </div>

            <div class="name">
              {{ user.isOpen ? user.name : user.userUuid === uuid ? '我' : '匿名' }}
            </div>
            <div class="status">
              <img
                class="icon-open"
                src="./images/icon-open.png"
                alt=""
                v-if="user.isOpen"
              />{{ user.isOpen ? '資料已公開' : '資料未公開' }}
            </div>
            <div class="score">
              <img src="./images/icon-gift.png" alt="" srcset="" />
              <span>{{ user.score }}</span>
            </div>
          </div>
        </div>
        <div class="message-box no-scrollbar" ref="chatContainer">
          <div class="message-list" ref="chatList">
            <template v-if="giftRecords && giftRecords.length">
              <div
                class="item"
                v-for="(item, index) of giftRecords"
                :key="index"
              >
                <div class="message">
                  <img
                    class="avatar"
                    src="./images/icon-self.png"
                    alt=""
                    srcset=""
                    v-if="item.userUuid === uuid"
                  />
                  <img
                    class="avatar"
                    src="./images/icon-other-user.png"
                    alt=""
                    srcset=""
                    v-else
                  />
                  <span class="send-info"
                    >送给{{ item.userUuid === uuid ? '对方' : '我' }}</span
                  >
                  <span>{{ item.giftName }}</span>
                  <img class="gift" :src="item.giftImageUrl" alt="" srcset="" />
                </div>
                <span class="count">x{{ item.giftCount }}</span>
              </div>
            </template>
          </div>
        </div>
        <button
          class="btn-open"
          type="button"
          @click="publishData()"
          v-if="mySelf && !mySelf.isOpen"
        >
          公開我的資料
        </button>
        <!-- <button class="btn-open" type="button" @click="setGiftRecords()">
          测试送礼
        </button> -->
        <ActionVue class="action"></ActionVue>
      </div>
    </div>
    <video-player
      class="im-video"
      ref="video"
      @onVideoEnded="playGiftAnimationEnd"
    ></video-player>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SettingVue from './setting.vue';
import AnonymousCallProvider from './anonymousCall';
import ActionVue from './action';
import mRtc from './mRtc';
import { getToken } from './api';
import VideoPlayer from './video.vue';

export default {
  name: 'OnPhone',
  components: {
    SettingVue,
    ActionVue,
    VideoPlayer
  },
  data() {
    return {
      AnonymousCallProvider,
      timeLeft: '5:00',
      timer: null,
      messageList: [
        {
          isSelf: true,
          giftName: '小愛心',
          giftUrl: '',
          count: 0
        }
      ],
      beEnding: false
    };
  },
  watch: {
    expireTime: {
      handler: function(nVal, oVal) {
        if (nVal != oVal) {
          this.startCountdown();
        }
      },
      immediate: true
    },
    giftRecords: {
      handler: function(nVal, oVal) {
        if ((nVal && !oVal) || (nVal && oVal && nVal.length != oVal.length)) {
          this.scrollChatToBottom();
          this.playGiftAnimation();
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo']),
    balance() {
      return this.accountInfo ? this.accountInfo.balance || 0 : 0;
    },
    isNotEnoughBalance() {
      return this.balance < 100;
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    user1() {
      return this.AnonymousCallProvider.user1;
    },
    user2() {
      return this.AnonymousCallProvider.user2;
    },
    userList() {
      return [this.user1, this.user2];
    },
    expireTime() {
      return this.AnonymousCallProvider.expireTime;
    },
    giftRecords() {
      return this.AnonymousCallProvider.giftRecords;
    },
    mySelf() {
      return this.userList.find(item => {
        return item.userUuid === this.uuid;
      });
    }
  },
  methods: {
    setGiftRecords() {
      let list = [
        {
          createTime: null,
          orderNo: Math.random(),
          userUuid: '1005826',
          playerUserUuid: '1002235',
          giftId: 123,
          giftName: '傳世皇冠',
          giftImageUrl: 'https://resource.3uplay.com/gift/voice-room/cshg.png',
          giftAnimationUrl:
            'https://resource.3uplay.com/gift/voice-room/cshg.mp4',
          giftCount: 1
        },
        {
          createTime: null,
          orderNo: Math.random(),
          userUuid: '1005826',
          playerUserUuid: '1002235',
          giftId: 206,
          giftName: '占星塔羅',
          giftImageUrl:
            'https://resource.funplus.social/user-static/3516c107.png',
          giftAnimationUrl:
            'https://resource.funplus.social/user-static/5df9beba.mp4',
          giftCount: 1
        }
      ];
      list = [...this.AnonymousCallProvider.giftRecords, ...list];
      this.AnonymousCallProvider.setGiftRecords(list);
    },
    playGiftAnimation() {
      if (this.AnonymousCallProvider.isPlayingAnimation) {
        return;
      }
      let url = this.AnonymousCallProvider.getAnimationUrl();
      if (url && this.$refs.video) {
        this.$refs.video.init(url);
      }
    },
    playGiftAnimationEnd() {
      this.AnonymousCallProvider.playAnimationEnd();
      this.playGiftAnimation();
    },
    scrollChatToBottom() {
      this.$nextTick(() => {
        this.$refs.chatContainer.scrollTop =
          this.$refs.chatList.scrollHeight -
          this.$refs.chatContainer.clientHeight;
      });
    },
    volumeIndicator() {
      mRtc.enableAudioVolumeIndicator();
      mRtc.client.on('volume-indicator', volumes => {
        try {
          volumes.forEach(volume => {
            const user = this.AnonymousCallProvider.userList.find(item => {
              return item.userUuid == volume.uid;
            });
            if (user) {
              user['volume'] = volume.level;
              if (volume.level && volume.level > 40) {
                user['volume'] = volume.level;
              } else {
                if (user['volume']) {
                  user['volume'] = 0;
                }
              }
            }
          });
        } catch (error) {
          this.$util.captureException(
            'voice-room',
            { roomUid: this.roomUid, fun: 'volumeIndicator' },
            error
          );
          console.log(error);
        }
      });
    },
    async subscribeAudio() {
      try {
        // 监听发布事件
        mRtc.client.on('user-published', async (user, mediaType) => {
          mRtc.subscribeRemoteUser(user, mediaType);
        });
        // 监听取消发布事件
        mRtc.client.on('user-unpublished', async user => {
          mRtc.remoteUser = null;
        });
      } catch (error) {
        console.log('subscribeAudio', error);
        this.$util.captureException(
          'anonymous',
          { roomUid: this.roomUid, fun: 'subscribeAudio' },
          error
        );
      }
    },
    async initRtc() {
      if (!(this.uuid && this.AnonymousCallProvider.roomUid)) {
        setTimeout(() => {
          this.initRtc();
        }, 2000);
        return;
      }
      try {
        const { data } = await getToken({
          roomUid: this.AnonymousCallProvider.roomUid
        });
        if (data) {
          this.subscribeAudio();
          await mRtc.join({
            appId: data.appId,
            channel: this.AnonymousCallProvider.roomUid,
            token: data.token,
            uid: Number(this.uuid)
          });
          await mRtc.initTrack();
          await mRtc.ready();
          await mRtc.publish();
          this.volumeIndicator();
          return true;
        }
      } catch (error) {
        console.log(error);
        throw new Error(
          '麥克風獲取失敗,請查看瀏覽器設置，確保已允許nicee使用你的麥克風'
        );
      }
    },
    toPlayerDetail(user) {
      if (user.isOpen) {
        this.$router.push({
          path: `/player-detail/${user.userUuid}`
        });
      }
    },
    async handleContinuous() {
      if (this.isNotEnoughBalance) {
        this.$confirm({
          content: '餘額不足,需要100幣',
          title: '提示',
          showCancelButton: true,
          confirmButtonText: '去儲值',
          closeOnClickModal: false
        }).then(() => {
          this.$router.push('/saving');
        });
      } else {
        this.$emit('continuous');
      }
    },
    cancel() {
      this.$emit('onCancel');
    },
    startCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      const currentTime = Math.floor(Date.now() / 1000);
      // 计算当前时间与 expireTime 的秒数差
      let totalSeconds = this.expireTime - currentTime;
      // let totalSeconds = 70;
      // let totalSeconds = 5 * 60;
      this.timer = setInterval(() => {
        totalSeconds--;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        this.timeLeft = `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
        if (minutes < 1) {
          this.beEnding = true;
        } else {
          this.beEnding = false;
        }
        if (totalSeconds === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    publishData() {
      const user = this.userList.find(item => item.userUuid === this.uuid);
      this.$emit('publish', user);
    },
    async leaveVoiceRoom() {
      await mRtc.leave();
    }
  },
  created() {
    this.initRtc();
  },
  beforeDestroy() {
    this.leaveVoiceRoom();
  }
};
</script>
<style lang="scss" scoped>
@keyframes pulse {
  0% {
    width: 100px;
    height: 100px;
    opacity: 1;
  }
  100% {
    width: 120px;
    height: 120px;
    opacity: 0;
  }
}
.on-phone-box {
  width: 100%;
  height: 100%;
  position: relative;
}
.on-phone {
  color: white;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  line-height: 1.5;
  position: relative;
  overflow: auto;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 40px;
    flex: none;
    position: relative;
    width: 100%;
    padding: 0 24px;
  }
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.55);
    /deep/ .el-popover__reference-wrapper {
      display: flex;
      align-items: center;
    }
    .time-box {
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 21px;
      img {
        width: 17px;
        height: auto;
        margin-right: 6px;
      }
    }
    .red-beg {
      width: 21px;
      height: auto;
      margin-left: 5px;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: auto;
    height: 1px;
    overflow: auto;
    padding-top: 30px;
    min-height: 600px;
  }
  .user-box {
    display: flex;
    justify-content: space-around;
    width: 100%;
    flex: none;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .avatar-box {
        cursor: pointer;
        width: 112px;
        height: 112px;
        position: relative;
        margin-bottom: 25px;
        &.speaking {
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 112px;
            height: 112px;
            // background-color: rgba(255, 255, 255, 0.2);
            background-color: inherit;
            border-radius: 50%;
            z-index: 1;
            animation: pulse 1s linear infinite;
            border: 10px solid white;
          }
        }
      }
      .avatar {
        background: #d9d9d9;
        border-radius: 1197.19px;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
      .name {
        font-size: 18px;
      }
      .status {
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.55);
        font-size: 15px;
        margin-top: 4px;
        .icon-open {
          width: 17px;
          height: auto;
        }
      }
      .score {
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.55);
        font-size: 13px;
        background: rgba(255, 255, 255, 0.07);
        border-radius: 1197.19px;
        padding: 0 8px;
        height: 20px;
        justify-content: center;
        line-height: 1;
        font-size: 13px;
        margin-top: 8px;
        img {
          width: 13px;
          height: auto;
          margin-right: 1px;
        }
      }
    }
  }
  .message-box {
    max-height: 300px;
    width: 100%;
    overflow: auto;
    position: relative;
    margin-top: 40px;
    margin-bottom: 40px;
    padding: 20px 50px;
    flex: 1;
    min-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      .avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        object-fit: contain;
        margin-right: 7px;
        background: #ffffff;
      }
      .gift {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(50%, -50%);
        width: 57px;
      }
      .message {
        background: rgba(255, 255, 255, 0.07);
        border-radius: 1198px;
        height: 44px;
        position: relative;
        padding: 0 35px 0 7px;
        display: flex;
        align-items: center;
        flex: none;
        margin-right: 37px;
      }
      .send-info {
        color: rgba(255, 255, 255, 0.35);
        margin-right: 4px;
      }
      .count {
        font-size: 20px;
      }
    }
  }
  .btn-open {
    border-radius: 1197.19px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.35);
    border-width: 2.4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 125.83px;
    height: 44.34px;
    color: rgba(255, 255, 255, 0.77);
    margin-bottom: 70px;
    flex: none;
  }
  .action {
    flex: none;
    margin-bottom: 40px;
  }
}
.im-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
</style>
<style lang="scss">
.on-phone-popover {
  color: rgba(255, 255, 255, 0.77) !important;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 8.39px;
  border: none;
  .phone-info {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.77);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .price {
      color: #111111;
      background: #ffcb46;
      border-radius: 1197.19px;
      padding: 3.6px 8.39px 3.6px 8.39px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    border-bottom-color: rgba(255, 255, 255, 0.07) !important;
  }
}
</style>
